/** @jsx jsx */
import { jsx } from 'theme-ui';
import Link from '../link';
import { ChildBucket, NavLink } from './primary-nav-css';

export const SinglePageContainer = (props) => (
  <div
    sx={{
      fontSize: '1.4rem',
      position: 'relative',
      height: '100%',
      display: ['none', null, 'flex'],
      ml: '2.4rem',
      pr: '2.4rem',
      alignItems: 'center',
      '&:hover': {
        ul: {
          display: 'block',
        },
      },
    }}
    {...props}
  />
);

export const ChildList = (props) => (
  <ChildBucket
    sx={{
      zIndex: 2,
      right: 0,
      left: 'auto !important',
      display: 'none',
    }}
    {...props}
  />
);

export const SectionLink = (props) => (
  <Link
    sx={{
      textDecoration: 'none',
      color: 'PrimaryDarkBlue',
      svg: {
        position: 'absolute',
        top: '29%',
      },
    }}
    {...props}
  />
);

export const ChildLink = (props) => (
  <NavLink
    sx={{
      fontWeight: 'body',
    }}
    {...props}
  />
);
